// Leiste neben dem roten Admin-Banner, solange eine Pricing-Simulation vom
// Default abweicht. Nur für Aivy-Admins und nur in diesem Browser.
import { useState } from 'react'

import { usePartnerContext, useUserContext } from '../../context'
import { usePricingAdminOverride } from '../../features/pricing/admin-override'
import { REAL_PLAN } from '../../features/pricing/entitlements'
import { PLANS } from '../../features/pricing/plans'
import AdminPricingDialog from './admin-pricing-dialog'

const ENFORCEMENT_TEXT = Object.freeze({
  flag: 'wie Flag',
  on: 'an',
  off: 'aus'
})

/** Kurzbeschreibung des Overrides für die Leiste */
export const describeAdminOverride = ({ enforcement, plan }) => {
  const planText = plan === REAL_PLAN ? 'echt' : PLANS[plan]?.name || plan
  return `Pricing-Simulation aktiv. Sperre ${
    ENFORCEMENT_TEXT[enforcement] || enforcement
  }, Paket ${planText}.`
}

const AdminPricingChip = () => {
  const { isAdmin } = useUserContext()
  const { partner } = usePartnerContext()
  const { available, active, override, reset } = usePricingAdminOverride({
    isAdmin,
    partnerId: partner?.id
  })
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  if (!available) return null

  // Der Dialog bleibt offen, auch wenn darin auf den Default zurückgestellt
  // wird und die Leiste verschwindet
  return (
    <>
      {active && (
        <div
          role='status'
          className='flex flex-wrap items-center justify-between gap-x-4 gap-y-1 bg-yellow-100 px-4 py-1.5 text-xs text-yellow-800'
        >
          <p className='font-medium'>{describeAdminOverride(override)}</p>
          <div className='flex items-center gap-3'>
            <button
              type='button'
              onClick={() => setIsDialogOpen(true)}
              className='rounded font-semibold underline-offset-2 hover:underline focus:outline-none focus-visible:ring-1 focus-visible:ring-yellow-800'
            >
              Ändern
            </button>
            <button
              type='button'
              onClick={reset}
              className='rounded font-semibold underline-offset-2 hover:underline focus:outline-none focus-visible:ring-1 focus-visible:ring-yellow-800'
            >
              Zurücksetzen
            </button>
          </div>
        </div>
      )}
      <AdminPricingDialog
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
      />
    </>
  )
}

export default AdminPricingChip
